export type StarIconClass = 'bi-star-fill' | 'bi-star-half' | 'bi-star';

export function getStarIconClass(position: number, value: number): StarIconClass {
  if (value >= position) return 'bi-star-fill';
  if (value >= position - 0.5) return 'bi-star-half';
  return 'bi-star';
}
